/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AboutRouteImport } from './routes/about'
import { Route as ActivityRouteImport } from './routes/activity'
import { Route as AddressesRouteImport } from './routes/addresses'
import { Route as BookingsRouteImport } from './routes/bookings'
import { Route as CartRouteImport } from './routes/cart'
import { Route as DownloadRouteImport } from './routes/download'
import { Route as InviteRouteImport } from './routes/invite'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as ProfileRouteImport } from './routes/profile'
import { Route as RefundRouteImport } from './routes/refund'
import { Route as SupportRouteImport } from './routes/support'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as AdminBookingsRouteImport } from './routes/admin.bookings'
import { Route as AdminKycRouteImport } from './routes/admin.kyc'
import { Route as AdminLoginRouteImport } from './routes/admin.login'
import { Route as AdminPayoutsRouteImport } from './routes/admin.payouts'
import { Route as AdminProfileRouteImport } from './routes/admin.profile'
import { Route as CategorySlugRouteImport } from './routes/category.$slug'
import { Route as ProIndexRouteImport } from './routes/pro/index'
import { Route as ProKycRouteImport } from './routes/pro/kyc'
import { Route as ProviderIndexRouteImport } from './routes/provider/index'
import { Route as ProviderEarningsRouteImport } from './routes/provider/earnings'
import { Route as ProviderLocationRouteImport } from './routes/provider/location'
import { Route as ProviderOnboardingRouteImport } from './routes/provider/onboarding'
import { Route as ProviderPayoutRouteImport } from './routes/provider/payout'
import { Route as ProviderPayoutsRouteImport } from './routes/provider/payouts'
import { Route as ProviderProfileRouteImport } from './routes/provider/profile'
import { Route as ServiceServiceIdRouteImport } from './routes/service.$serviceId'
import { Route as TrackingBookingIdRouteImport } from './routes/tracking.$bookingId'
import { Route as AdminTeamsIndexRouteImport } from './routes/admin.teams.index'
import { Route as AdminTeamsSpUserIdRouteImport } from './routes/admin.teams.$spUserId'
import { Route as ProJobsIndexRouteImport } from './routes/pro/jobs/index'
import { Route as ProJobsBookingIdRouteImport } from './routes/pro/jobs/$bookingId'
import { Route as ProviderBookingsIndexRouteImport } from './routes/provider/bookings/index'
import { Route as ProviderBookingsBookingIdRouteImport } from './routes/provider/bookings/$bookingId'
import { Route as ProviderTeamIndexRouteImport } from './routes/provider/team/index'
import { Route as ProviderTeamInviteRouteImport } from './routes/provider/team/invite'
import { Route as ProviderTeamProfessionalIdEarningsRouteImport } from './routes/provider/team/$professionalId.earnings'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AboutRoute = AboutRouteImport.update({
  id: '/about',
  path: '/about',
  getParentRoute: () => rootRouteImport,
} as any)
const ActivityRoute = ActivityRouteImport.update({
  id: '/activity',
  path: '/activity',
  getParentRoute: () => rootRouteImport,
} as any)
const AddressesRoute = AddressesRouteImport.update({
  id: '/addresses',
  path: '/addresses',
  getParentRoute: () => rootRouteImport,
} as any)
const BookingsRoute = BookingsRouteImport.update({
  id: '/bookings',
  path: '/bookings',
  getParentRoute: () => rootRouteImport,
} as any)
const CartRoute = CartRouteImport.update({
  id: '/cart',
  path: '/cart',
  getParentRoute: () => rootRouteImport,
} as any)
const DownloadRoute = DownloadRouteImport.update({
  id: '/download',
  path: '/download',
  getParentRoute: () => rootRouteImport,
} as any)
const InviteRoute = InviteRouteImport.update({
  id: '/invite',
  path: '/invite',
  getParentRoute: () => rootRouteImport,
} as any)
const PrivacyRoute = PrivacyRouteImport.update({
  id: '/privacy',
  path: '/privacy',
  getParentRoute: () => rootRouteImport,
} as any)
const ProfileRoute = ProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => rootRouteImport,
} as any)
const RefundRoute = RefundRouteImport.update({
  id: '/refund',
  path: '/refund',
  getParentRoute: () => rootRouteImport,
} as any)
const SupportRoute = SupportRouteImport.update({
  id: '/support',
  path: '/support',
  getParentRoute: () => rootRouteImport,
} as any)
const TermsRoute = TermsRouteImport.update({
  id: '/terms',
  path: '/terms',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminBookingsRoute = AdminBookingsRouteImport.update({
  id: '/admin/bookings',
  path: '/admin/bookings',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminKycRoute = AdminKycRouteImport.update({
  id: '/admin/kyc',
  path: '/admin/kyc',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminLoginRoute = AdminLoginRouteImport.update({
  id: '/admin/login',
  path: '/admin/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminPayoutsRoute = AdminPayoutsRouteImport.update({
  id: '/admin/payouts',
  path: '/admin/payouts',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminProfileRoute = AdminProfileRouteImport.update({
  id: '/admin/profile',
  path: '/admin/profile',
  getParentRoute: () => rootRouteImport,
} as any)
const CategorySlugRoute = CategorySlugRouteImport.update({
  id: '/category/$slug',
  path: '/category/$slug',
  getParentRoute: () => rootRouteImport,
} as any)
const ProIndexRoute = ProIndexRouteImport.update({
  id: '/pro/',
  path: '/pro/',
  getParentRoute: () => rootRouteImport,
} as any)
const ProKycRoute = ProKycRouteImport.update({
  id: '/pro/kyc',
  path: '/pro/kyc',
  getParentRoute: () => rootRouteImport,
} as any)
const ProviderIndexRoute = ProviderIndexRouteImport.update({
  id: '/provider/',
  path: '/provider/',
  getParentRoute: () => rootRouteImport,
} as any)
const ProviderEarningsRoute = ProviderEarningsRouteImport.update({
  id: '/provider/earnings',
  path: '/provider/earnings',
  getParentRoute: () => rootRouteImport,
} as any)
const ProviderLocationRoute = ProviderLocationRouteImport.update({
  id: '/provider/location',
  path: '/provider/location',
  getParentRoute: () => rootRouteImport,
} as any)
const ProviderOnboardingRoute = ProviderOnboardingRouteImport.update({
  id: '/provider/onboarding',
  path: '/provider/onboarding',
  getParentRoute: () => rootRouteImport,
} as any)
const ProviderPayoutRoute = ProviderPayoutRouteImport.update({
  id: '/provider/payout',
  path: '/provider/payout',
  getParentRoute: () => rootRouteImport,
} as any)
const ProviderPayoutsRoute = ProviderPayoutsRouteImport.update({
  id: '/provider/payouts',
  path: '/provider/payouts',
  getParentRoute: () => rootRouteImport,
} as any)
const ProviderProfileRoute = ProviderProfileRouteImport.update({
  id: '/provider/profile',
  path: '/provider/profile',
  getParentRoute: () => rootRouteImport,
} as any)
const ServiceServiceIdRoute = ServiceServiceIdRouteImport.update({
  id: '/service/$serviceId',
  path: '/service/$serviceId',
  getParentRoute: () => rootRouteImport,
} as any)
const TrackingBookingIdRoute = TrackingBookingIdRouteImport.update({
  id: '/tracking/$bookingId',
  path: '/tracking/$bookingId',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminTeamsIndexRoute = AdminTeamsIndexRouteImport.update({
  id: '/admin/teams/',
  path: '/admin/teams/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminTeamsSpUserIdRoute = AdminTeamsSpUserIdRouteImport.update({
  id: '/admin/teams/$spUserId',
  path: '/admin/teams/$spUserId',
  getParentRoute: () => rootRouteImport,
} as any)
const ProJobsIndexRoute = ProJobsIndexRouteImport.update({
  id: '/pro/jobs/',
  path: '/pro/jobs/',
  getParentRoute: () => rootRouteImport,
} as any)
const ProJobsBookingIdRoute = ProJobsBookingIdRouteImport.update({
  id: '/pro/jobs/$bookingId',
  path: '/pro/jobs/$bookingId',
  getParentRoute: () => rootRouteImport,
} as any)
const ProviderBookingsIndexRoute = ProviderBookingsIndexRouteImport.update({
  id: '/provider/bookings/',
  path: '/provider/bookings/',
  getParentRoute: () => rootRouteImport,
} as any)
const ProviderBookingsBookingIdRoute =
  ProviderBookingsBookingIdRouteImport.update({
    id: '/provider/bookings/$bookingId',
    path: '/provider/bookings/$bookingId',
    getParentRoute: () => rootRouteImport,
  } as any)
const ProviderTeamIndexRoute = ProviderTeamIndexRouteImport.update({
  id: '/provider/team/',
  path: '/provider/team/',
  getParentRoute: () => rootRouteImport,
} as any)
const ProviderTeamInviteRoute = ProviderTeamInviteRouteImport.update({
  id: '/provider/team/invite',
  path: '/provider/team/invite',
  getParentRoute: () => rootRouteImport,
} as any)
const ProviderTeamProfessionalIdEarningsRoute =
  ProviderTeamProfessionalIdEarningsRouteImport.update({
    id: '/provider/team/$professionalId/earnings',
    path: '/provider/team/$professionalId/earnings',
    getParentRoute: () => rootRouteImport,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/about': typeof AboutRoute
  '/activity': typeof ActivityRoute
  '/addresses': typeof AddressesRoute
  '/bookings': typeof BookingsRoute
  '/cart': typeof CartRoute
  '/download': typeof DownloadRoute
  '/invite': typeof InviteRoute
  '/privacy': typeof PrivacyRoute
  '/profile': typeof ProfileRoute
  '/refund': typeof RefundRoute
  '/support': typeof SupportRoute
  '/terms': typeof TermsRoute
  '/admin/bookings': typeof AdminBookingsRoute
  '/admin/kyc': typeof AdminKycRoute
  '/admin/login': typeof AdminLoginRoute
  '/admin/payouts': typeof AdminPayoutsRoute
  '/admin/profile': typeof AdminProfileRoute
  '/category/$slug': typeof CategorySlugRoute
  '/pro/kyc': typeof ProKycRoute
  '/provider/earnings': typeof ProviderEarningsRoute
  '/provider/location': typeof ProviderLocationRoute
  '/provider/onboarding': typeof ProviderOnboardingRoute
  '/provider/payout': typeof ProviderPayoutRoute
  '/provider/payouts': typeof ProviderPayoutsRoute
  '/provider/profile': typeof ProviderProfileRoute
  '/service/$serviceId': typeof ServiceServiceIdRoute
  '/tracking/$bookingId': typeof TrackingBookingIdRoute
  '/pro/': typeof ProIndexRoute
  '/provider/': typeof ProviderIndexRoute
  '/admin/teams/$spUserId': typeof AdminTeamsSpUserIdRoute
  '/pro/jobs/$bookingId': typeof ProJobsBookingIdRoute
  '/provider/bookings/$bookingId': typeof ProviderBookingsBookingIdRoute
  '/provider/team/invite': typeof ProviderTeamInviteRoute
  '/admin/teams/': typeof AdminTeamsIndexRoute
  '/pro/jobs/': typeof ProJobsIndexRoute
  '/provider/bookings/': typeof ProviderBookingsIndexRoute
  '/provider/team/': typeof ProviderTeamIndexRoute
  '/provider/team/$professionalId/earnings': typeof ProviderTeamProfessionalIdEarningsRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/about': typeof AboutRoute
  '/activity': typeof ActivityRoute
  '/addresses': typeof AddressesRoute
  '/bookings': typeof BookingsRoute
  '/cart': typeof CartRoute
  '/download': typeof DownloadRoute
  '/invite': typeof InviteRoute
  '/privacy': typeof PrivacyRoute
  '/profile': typeof ProfileRoute
  '/refund': typeof RefundRoute
  '/support': typeof SupportRoute
  '/terms': typeof TermsRoute
  '/admin/bookings': typeof AdminBookingsRoute
  '/admin/kyc': typeof AdminKycRoute
  '/admin/login': typeof AdminLoginRoute
  '/admin/payouts': typeof AdminPayoutsRoute
  '/admin/profile': typeof AdminProfileRoute
  '/category/$slug': typeof CategorySlugRoute
  '/pro/kyc': typeof ProKycRoute
  '/provider/earnings': typeof ProviderEarningsRoute
  '/provider/location': typeof ProviderLocationRoute
  '/provider/onboarding': typeof ProviderOnboardingRoute
  '/provider/payout': typeof ProviderPayoutRoute
  '/provider/payouts': typeof ProviderPayoutsRoute
  '/provider/profile': typeof ProviderProfileRoute
  '/service/$serviceId': typeof ServiceServiceIdRoute
  '/tracking/$bookingId': typeof TrackingBookingIdRoute
  '/pro': typeof ProIndexRoute
  '/provider': typeof ProviderIndexRoute
  '/admin/teams/$spUserId': typeof AdminTeamsSpUserIdRoute
  '/pro/jobs/$bookingId': typeof ProJobsBookingIdRoute
  '/provider/bookings/$bookingId': typeof ProviderBookingsBookingIdRoute
  '/provider/team/invite': typeof ProviderTeamInviteRoute
  '/admin/teams': typeof AdminTeamsIndexRoute
  '/pro/jobs': typeof ProJobsIndexRoute
  '/provider/bookings': typeof ProviderBookingsIndexRoute
  '/provider/team': typeof ProviderTeamIndexRoute
  '/provider/team/$professionalId/earnings': typeof ProviderTeamProfessionalIdEarningsRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/about': typeof AboutRoute
  '/activity': typeof ActivityRoute
  '/addresses': typeof AddressesRoute
  '/bookings': typeof BookingsRoute
  '/cart': typeof CartRoute
  '/download': typeof DownloadRoute
  '/invite': typeof InviteRoute
  '/privacy': typeof PrivacyRoute
  '/profile': typeof ProfileRoute
  '/refund': typeof RefundRoute
  '/support': typeof SupportRoute
  '/terms': typeof TermsRoute
  '/admin/bookings': typeof AdminBookingsRoute
  '/admin/kyc': typeof AdminKycRoute
  '/admin/login': typeof AdminLoginRoute
  '/admin/payouts': typeof AdminPayoutsRoute
  '/admin/profile': typeof AdminProfileRoute
  '/category/$slug': typeof CategorySlugRoute
  '/pro/kyc': typeof ProKycRoute
  '/provider/earnings': typeof ProviderEarningsRoute
  '/provider/location': typeof ProviderLocationRoute
  '/provider/onboarding': typeof ProviderOnboardingRoute
  '/provider/payout': typeof ProviderPayoutRoute
  '/provider/payouts': typeof ProviderPayoutsRoute
  '/provider/profile': typeof ProviderProfileRoute
  '/service/$serviceId': typeof ServiceServiceIdRoute
  '/tracking/$bookingId': typeof TrackingBookingIdRoute
  '/pro/': typeof ProIndexRoute
  '/provider/': typeof ProviderIndexRoute
  '/admin/teams/$spUserId': typeof AdminTeamsSpUserIdRoute
  '/pro/jobs/$bookingId': typeof ProJobsBookingIdRoute
  '/provider/bookings/$bookingId': typeof ProviderBookingsBookingIdRoute
  '/provider/team/invite': typeof ProviderTeamInviteRoute
  '/admin/teams/': typeof AdminTeamsIndexRoute
  '/pro/jobs/': typeof ProJobsIndexRoute
  '/provider/bookings/': typeof ProviderBookingsIndexRoute
  '/provider/team/': typeof ProviderTeamIndexRoute
  '/provider/team/$professionalId/earnings': typeof ProviderTeamProfessionalIdEarningsRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/about'
    | '/activity'
    | '/addresses'
    | '/bookings'
    | '/cart'
    | '/download'
    | '/invite'
    | '/privacy'
    | '/profile'
    | '/refund'
    | '/support'
    | '/terms'
    | '/admin/bookings'
    | '/admin/kyc'
    | '/admin/login'
    | '/admin/payouts'
    | '/admin/profile'
    | '/category/$slug'
    | '/pro/kyc'
    | '/provider/earnings'
    | '/provider/location'
    | '/provider/onboarding'
    | '/provider/payout'
    | '/provider/payouts'
    | '/provider/profile'
    | '/service/$serviceId'
    | '/tracking/$bookingId'
    | '/pro/'
    | '/provider/'
    | '/admin/teams/$spUserId'
    | '/pro/jobs/$bookingId'
    | '/provider/bookings/$bookingId'
    | '/provider/team/invite'
    | '/admin/teams/'
    | '/pro/jobs/'
    | '/provider/bookings/'
    | '/provider/team/'
    | '/provider/team/$professionalId/earnings'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/about'
    | '/activity'
    | '/addresses'
    | '/bookings'
    | '/cart'
    | '/download'
    | '/invite'
    | '/privacy'
    | '/profile'
    | '/refund'
    | '/support'
    | '/terms'
    | '/admin/bookings'
    | '/admin/kyc'
    | '/admin/login'
    | '/admin/payouts'
    | '/admin/profile'
    | '/category/$slug'
    | '/pro/kyc'
    | '/provider/earnings'
    | '/provider/location'
    | '/provider/onboarding'
    | '/provider/payout'
    | '/provider/payouts'
    | '/provider/profile'
    | '/service/$serviceId'
    | '/tracking/$bookingId'
    | '/pro'
    | '/provider'
    | '/admin/teams/$spUserId'
    | '/pro/jobs/$bookingId'
    | '/provider/bookings/$bookingId'
    | '/provider/team/invite'
    | '/admin/teams'
    | '/pro/jobs'
    | '/provider/bookings'
    | '/provider/team'
    | '/provider/team/$professionalId/earnings'
  id:
    | '__root__'
    | '/'
    | '/about'
    | '/activity'
    | '/addresses'
    | '/bookings'
    | '/cart'
    | '/download'
    | '/invite'
    | '/privacy'
    | '/profile'
    | '/refund'
    | '/support'
    | '/terms'
    | '/admin/bookings'
    | '/admin/kyc'
    | '/admin/login'
    | '/admin/payouts'
    | '/admin/profile'
    | '/category/$slug'
    | '/pro/kyc'
    | '/provider/earnings'
    | '/provider/location'
    | '/provider/onboarding'
    | '/provider/payout'
    | '/provider/payouts'
    | '/provider/profile'
    | '/service/$serviceId'
    | '/tracking/$bookingId'
    | '/pro/'
    | '/provider/'
    | '/admin/teams/$spUserId'
    | '/pro/jobs/$bookingId'
    | '/provider/bookings/$bookingId'
    | '/provider/team/invite'
    | '/admin/teams/'
    | '/pro/jobs/'
    | '/provider/bookings/'
    | '/provider/team/'
    | '/provider/team/$professionalId/earnings'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AboutRoute: typeof AboutRoute
  ActivityRoute: typeof ActivityRoute
  AddressesRoute: typeof AddressesRoute
  BookingsRoute: typeof BookingsRoute
  CartRoute: typeof CartRoute
  DownloadRoute: typeof DownloadRoute
  InviteRoute: typeof InviteRoute
  PrivacyRoute: typeof PrivacyRoute
  ProfileRoute: typeof ProfileRoute
  RefundRoute: typeof RefundRoute
  SupportRoute: typeof SupportRoute
  TermsRoute: typeof TermsRoute
  AdminBookingsRoute: typeof AdminBookingsRoute
  AdminKycRoute: typeof AdminKycRoute
  AdminLoginRoute: typeof AdminLoginRoute
  AdminPayoutsRoute: typeof AdminPayoutsRoute
  AdminProfileRoute: typeof AdminProfileRoute
  CategorySlugRoute: typeof CategorySlugRoute
  ProKycRoute: typeof ProKycRoute
  ProviderEarningsRoute: typeof ProviderEarningsRoute
  ProviderLocationRoute: typeof ProviderLocationRoute
  ProviderOnboardingRoute: typeof ProviderOnboardingRoute
  ProviderPayoutRoute: typeof ProviderPayoutRoute
  ProviderPayoutsRoute: typeof ProviderPayoutsRoute
  ProviderProfileRoute: typeof ProviderProfileRoute
  ServiceServiceIdRoute: typeof ServiceServiceIdRoute
  TrackingBookingIdRoute: typeof TrackingBookingIdRoute
  ProIndexRoute: typeof ProIndexRoute
  ProviderIndexRoute: typeof ProviderIndexRoute
  AdminTeamsSpUserIdRoute: typeof AdminTeamsSpUserIdRoute
  ProJobsBookingIdRoute: typeof ProJobsBookingIdRoute
  ProviderBookingsBookingIdRoute: typeof ProviderBookingsBookingIdRoute
  ProviderTeamInviteRoute: typeof ProviderTeamInviteRoute
  AdminTeamsIndexRoute: typeof AdminTeamsIndexRoute
  ProJobsIndexRoute: typeof ProJobsIndexRoute
  ProviderBookingsIndexRoute: typeof ProviderBookingsIndexRoute
  ProviderTeamIndexRoute: typeof ProviderTeamIndexRoute
  ProviderTeamProfessionalIdEarningsRoute: typeof ProviderTeamProfessionalIdEarningsRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/about': {
      id: '/about'
      path: '/about'
      fullPath: '/about'
      preLoaderRoute: typeof AboutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/activity': {
      id: '/activity'
      path: '/activity'
      fullPath: '/activity'
      preLoaderRoute: typeof ActivityRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/addresses': {
      id: '/addresses'
      path: '/addresses'
      fullPath: '/addresses'
      preLoaderRoute: typeof AddressesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/bookings': {
      id: '/bookings'
      path: '/bookings'
      fullPath: '/bookings'
      preLoaderRoute: typeof BookingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/cart': {
      id: '/cart'
      path: '/cart'
      fullPath: '/cart'
      preLoaderRoute: typeof CartRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/download': {
      id: '/download'
      path: '/download'
      fullPath: '/download'
      preLoaderRoute: typeof DownloadRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/invite': {
      id: '/invite'
      path: '/invite'
      fullPath: '/invite'
      preLoaderRoute: typeof InviteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/privacy': {
      id: '/privacy'
      path: '/privacy'
      fullPath: '/privacy'
      preLoaderRoute: typeof PrivacyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/profile': {
      id: '/profile'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof ProfileRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/refund': {
      id: '/refund'
      path: '/refund'
      fullPath: '/refund'
      preLoaderRoute: typeof RefundRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/support': {
      id: '/support'
      path: '/support'
      fullPath: '/support'
      preLoaderRoute: typeof SupportRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/terms': {
      id: '/terms'
      path: '/terms'
      fullPath: '/terms'
      preLoaderRoute: typeof TermsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/bookings': {
      id: '/admin/bookings'
      path: '/admin/bookings'
      fullPath: '/admin/bookings'
      preLoaderRoute: typeof AdminBookingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/kyc': {
      id: '/admin/kyc'
      path: '/admin/kyc'
      fullPath: '/admin/kyc'
      preLoaderRoute: typeof AdminKycRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/login': {
      id: '/admin/login'
      path: '/admin/login'
      fullPath: '/admin/login'
      preLoaderRoute: typeof AdminLoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/payouts': {
      id: '/admin/payouts'
      path: '/admin/payouts'
      fullPath: '/admin/payouts'
      preLoaderRoute: typeof AdminPayoutsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/profile': {
      id: '/admin/profile'
      path: '/admin/profile'
      fullPath: '/admin/profile'
      preLoaderRoute: typeof AdminProfileRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/category/$slug': {
      id: '/category/$slug'
      path: '/category/$slug'
      fullPath: '/category/$slug'
      preLoaderRoute: typeof CategorySlugRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/pro/': {
      id: '/pro/'
      path: '/pro'
      fullPath: '/pro/'
      preLoaderRoute: typeof ProIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/pro/kyc': {
      id: '/pro/kyc'
      path: '/pro/kyc'
      fullPath: '/pro/kyc'
      preLoaderRoute: typeof ProKycRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/provider/': {
      id: '/provider/'
      path: '/provider'
      fullPath: '/provider/'
      preLoaderRoute: typeof ProviderIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/provider/earnings': {
      id: '/provider/earnings'
      path: '/provider/earnings'
      fullPath: '/provider/earnings'
      preLoaderRoute: typeof ProviderEarningsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/provider/location': {
      id: '/provider/location'
      path: '/provider/location'
      fullPath: '/provider/location'
      preLoaderRoute: typeof ProviderLocationRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/provider/onboarding': {
      id: '/provider/onboarding'
      path: '/provider/onboarding'
      fullPath: '/provider/onboarding'
      preLoaderRoute: typeof ProviderOnboardingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/provider/payout': {
      id: '/provider/payout'
      path: '/provider/payout'
      fullPath: '/provider/payout'
      preLoaderRoute: typeof ProviderPayoutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/provider/payouts': {
      id: '/provider/payouts'
      path: '/provider/payouts'
      fullPath: '/provider/payouts'
      preLoaderRoute: typeof ProviderPayoutsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/provider/profile': {
      id: '/provider/profile'
      path: '/provider/profile'
      fullPath: '/provider/profile'
      preLoaderRoute: typeof ProviderProfileRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/service/$serviceId': {
      id: '/service/$serviceId'
      path: '/service/$serviceId'
      fullPath: '/service/$serviceId'
      preLoaderRoute: typeof ServiceServiceIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/tracking/$bookingId': {
      id: '/tracking/$bookingId'
      path: '/tracking/$bookingId'
      fullPath: '/tracking/$bookingId'
      preLoaderRoute: typeof TrackingBookingIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/teams/': {
      id: '/admin/teams/'
      path: '/admin/teams'
      fullPath: '/admin/teams/'
      preLoaderRoute: typeof AdminTeamsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/teams/$spUserId': {
      id: '/admin/teams/$spUserId'
      path: '/admin/teams/$spUserId'
      fullPath: '/admin/teams/$spUserId'
      preLoaderRoute: typeof AdminTeamsSpUserIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/pro/jobs/': {
      id: '/pro/jobs/'
      path: '/pro/jobs'
      fullPath: '/pro/jobs/'
      preLoaderRoute: typeof ProJobsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/pro/jobs/$bookingId': {
      id: '/pro/jobs/$bookingId'
      path: '/pro/jobs/$bookingId'
      fullPath: '/pro/jobs/$bookingId'
      preLoaderRoute: typeof ProJobsBookingIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/provider/bookings/': {
      id: '/provider/bookings/'
      path: '/provider/bookings'
      fullPath: '/provider/bookings/'
      preLoaderRoute: typeof ProviderBookingsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/provider/bookings/$bookingId': {
      id: '/provider/bookings/$bookingId'
      path: '/provider/bookings/$bookingId'
      fullPath: '/provider/bookings/$bookingId'
      preLoaderRoute: typeof ProviderBookingsBookingIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/provider/team/': {
      id: '/provider/team/'
      path: '/provider/team'
      fullPath: '/provider/team/'
      preLoaderRoute: typeof ProviderTeamIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/provider/team/invite': {
      id: '/provider/team/invite'
      path: '/provider/team/invite'
      fullPath: '/provider/team/invite'
      preLoaderRoute: typeof ProviderTeamInviteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/provider/team/$professionalId/earnings': {
      id: '/provider/team/$professionalId/earnings'
      path: '/provider/team/$professionalId/earnings'
      fullPath: '/provider/team/$professionalId/earnings'
      preLoaderRoute: typeof ProviderTeamProfessionalIdEarningsRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AboutRoute: AboutRoute,
  ActivityRoute: ActivityRoute,
  AddressesRoute: AddressesRoute,
  BookingsRoute: BookingsRoute,
  CartRoute: CartRoute,
  DownloadRoute: DownloadRoute,
  InviteRoute: InviteRoute,
  PrivacyRoute: PrivacyRoute,
  ProfileRoute: ProfileRoute,
  RefundRoute: RefundRoute,
  SupportRoute: SupportRoute,
  TermsRoute: TermsRoute,
  AdminBookingsRoute: AdminBookingsRoute,
  AdminKycRoute: AdminKycRoute,
  AdminLoginRoute: AdminLoginRoute,
  AdminPayoutsRoute: AdminPayoutsRoute,
  AdminProfileRoute: AdminProfileRoute,
  CategorySlugRoute: CategorySlugRoute,
  ProKycRoute: ProKycRoute,
  ProviderEarningsRoute: ProviderEarningsRoute,
  ProviderLocationRoute: ProviderLocationRoute,
  ProviderOnboardingRoute: ProviderOnboardingRoute,
  ProviderPayoutRoute: ProviderPayoutRoute,
  ProviderPayoutsRoute: ProviderPayoutsRoute,
  ProviderProfileRoute: ProviderProfileRoute,
  ServiceServiceIdRoute: ServiceServiceIdRoute,
  TrackingBookingIdRoute: TrackingBookingIdRoute,
  ProIndexRoute: ProIndexRoute,
  ProviderIndexRoute: ProviderIndexRoute,
  AdminTeamsSpUserIdRoute: AdminTeamsSpUserIdRoute,
  ProJobsBookingIdRoute: ProJobsBookingIdRoute,
  ProviderBookingsBookingIdRoute: ProviderBookingsBookingIdRoute,
  ProviderTeamInviteRoute: ProviderTeamInviteRoute,
  AdminTeamsIndexRoute: AdminTeamsIndexRoute,
  ProJobsIndexRoute: ProJobsIndexRoute,
  ProviderBookingsIndexRoute: ProviderBookingsIndexRoute,
  ProviderTeamIndexRoute: ProviderTeamIndexRoute,
  ProviderTeamProfessionalIdEarningsRoute:
    ProviderTeamProfessionalIdEarningsRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

import type { getRouter } from './router.tsx'
import type { createStart } from '@tanstack/react-start'
declare module '@tanstack/react-start' {
  interface Register {
    ssr: true
    router: Awaited<ReturnType<typeof getRouter>>
  }
}
